import { NumberBox, SelectBox, TextArea } from "devextreme-react";
import { useEffect, useState, useReducer } from "react";
import DleReducer from "../../../reducers/dle";
import * as actions from "../../../actions/dle";
import { compact, filter, isNumber, sumBy } from "lodash";

const initialState = { level2Codes: [] };

const ReasonCodeEntry = (props) => {
  const [state, dispatch] = useReducer(DleReducer, initialState);

  const [reasons, setReasons] = useState([]);

  const { level2Codes } = state;

  const {
    setReasonData,
    tierId,
    reasonsData,
    earnedHour,
    paidHour,
    target,
    eHr,
    pHr,
  } = props;

  useEffect(() => {
    actions.fetchReasonCodeLevel2(dispatch, tierId);
  }, []);

  useEffect(() => {
    setReasons(
      reasonsData.map((obj, index) => {
        return { ...obj, index };
      })
    );
  }, [reasonsData]);

  useEffect(() => {
    const updatedReason = getReasonIdByUsingValues(reasons);
    setReasonData(updatedReason);
  }, [reasons]);

  useEffect(() => {
    let sDle = (eHr / pHr) * 100;

    if (sDle > target) {
      setReasons([]);
    }
  }, [eHr, pHr]);

  const addReason = () => {
    let sDle = (eHr / pHr) * 100;

    if (isNumber(paidHour) && isNumber(earnedHour) && sDle < target) {
      // const qty = paidHour - earnedHour;
      // let currentMissQty = sumBy(reasons, (reason) => reason.qty);
      // if (qty !== currentMissQty) {
      setReasons((prev) => [
        ...prev,
        {
          index: reasons.length
            ? reasons[reasons.length - 1]?.index + 1
            : reasons.length + 1,
          // qty: qty - currentMissQty,
        },
      ]);
      //  }
      //return;
    }
  };

  const deleteReason = (i) => {
    setReasons((prev) => prev.filter((obj) => obj.index !== i));
  };

  const getReasonIdByUsingValues = (reasons) => {
    reasons.map((reason) => {
      const { level0, level1, level2 } = reason;
 
      const reasonCode = filter(level2Codes, (e) => {
        if (
          e.level0 === level0 &&
          e.value === level1 &&
          (level2 ? e.level2 === level2 : true)
        ) {
          return e.id;
        }
      });
      reason["id"] = reasonCode[0]?.id;
      reason["reasonCodeId"] = reasonCode[0]?.id;
    });
    return reasons;
  };

  return (
    <div>
      <div
        className="reasons"
        style={{
          borderLeft: "1px solid white",
          borderRight: "1px solid white",
          borderBottom: "1px solid white",
          borderTop: "1px solid white",
          borderRadius: "5px",
          padding: "15px 15px 15px 15px",
        }}
      >
        <div
          className="reason-head"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h3>Reason Code</h3>

          <span
            onClick={addReason}
            style={{
              cursor: "pointer",
            }}
          >
            <i
              className="fas fa-plus safetyAlert"
              title="Add Reason Code"
              style={{
                marginRight: "5px",
              }}
            ></i>{" "}
            Add Reason Code
          </span>
        </div>

        {reasons.map((reason, index) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
            key={reason.index}
          >
            <SelectBox
              dataSource={
                level2Codes
                  ? compact([...new Set(level2Codes.map((d) => d.level0))])
                  : []
              }
              labelMode={"floating"}
              wrapItemText={true}
              label="Level 0"
              value={reason.level0}
              searchEnabled={true}
              onValueChanged={(e) => {
                if (e.event === undefined) return;
                const tempReason = [...reasons];
                tempReason[index]["level0"] = e.value;
                setReasons(tempReason);
              }}
            />

            <SelectBox
              dataSource={
                level2Codes
                  ? compact([
                      ...new Set(
                        level2Codes.map((d) => {
                          if (d.level0 == reason.level0) return d.value;
                        })
                      ),
                    ])
                  : []
              }
              labelMode={"floating"}
              wrapItemText={true}
              label="Level 1"
              searchEnabled={true}
              value={reason.level1}
              onValueChanged={(e) => {
                if (e.event === undefined) return;
                const tempReason = [...reasons];
                tempReason[index]["level1"] = e.value;
                setReasons(tempReason);
              }}
              style={{ marginLeft: "15px" }}
            />
             <SelectBox
              dataSource={
                level2Codes
                ? compact([
                  ...new Set(
                    level2Codes.map((d) => {
                      if (d.value === reason.level1) return d.level2;
                    })
                  ),
                ])
              : []
              }
              labelMode={"floating"}
              wrapItemText={true}
              label="Level 2"
              searchEnabled={true}
              value={reason.level2}
              onValueChanged={(e) => {
                if (e.event === undefined) return;
                const tempReason = [...reasons];
                tempReason[index]["level2"] = e.value;
                setReasons(tempReason);
              }}
              style={{ marginLeft: "15px" }}
            />

            <TextArea
              style={{
                height: "50px",
                padding: "6px",
                marginLeft: "15px",
              }}
              labelMode={"floating"}
              label="Description"
              value={reason.comment}
              maxLength={300}
              onValueChanged={(e) => {
                if (e.event === undefined) return;
                const tempReason = [...reasons];
                tempReason[index]["comment"] = e.value;
                setReasons(tempReason);
              }}
              min={0}
            />

            <div
              className="shft-del-btn"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                marginLeft: "15px",
                cursor: "pointer",
              }}
              onClick={() => deleteReason(reason.index)}
            >
              <span>
                <i className="dx-link dx-link-delete dx-icon-trash dx-link-icon " />{" "}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReasonCodeEntry;
